<script setup lang="ts">
    import { useSlots } from 'vue';
    import EchoPopover from './EchoPopover.vue';
    import IconButton from './IconButton.vue';
    import { __ } from '../stores/expressions';
    import { InfoIcon } from '@lucide/vue';

    defineOptions({
        inheritAttrs: false,
    });

    withDefaults(
        defineProps<{
            helpHint?: string;
        }>(),
        {
            helpHint: '',
        }
    );

    const slots = useSlots();

    const labelClasses = 'text-overline mb-1 block';
</script>
<template>
    <template v-if="slots.help">
        <EchoPopover type="text">
            <template #button="{ anchor, togglePopover, buttonAttrs }">
                <div class="flex flex-wrap items-end">
                    <label v-bind="$attrs" :class="labelClasses">
                        <slot />
                    </label>
                    <div class="ml-1.5 self-start">
                        <div class="-m-0.5">
                            <IconButton
                                v-if="slots.help"
                                :ref="anchor"
                                :tooltip="helpHint"
                                size="size-5"
                                area-size="size-6"
                                :aria-label="__('show-info')"
                                v-bind="buttonAttrs"
                                @click="togglePopover"
                            >
                                <InfoIcon class="size-5" />
                            </IconButton>
                        </div>
                    </div>
                </div>
            </template>
            <template #popover>
                <slot name="help" />
            </template>
        </EchoPopover>
    </template>
    <label v-else v-bind="$attrs" :class="labelClasses">
        <slot />
    </label>
</template>
